let revit_speed = 0.3;
let revit_track = null;
let revit_cards_items = null;
let revit_translateX = 0;
let revit_trackWidth = null;
let revit_keepScrolling = true;
let revit_carousel_obj = null;
let revit_carouselWidth = null;

const initScrollValues = () => {
    if (!revit_track) {
        revit_track = document.querySelector(".revit_track");
    }

    if (!revit_cards_items) {
        revit_cards_items = document.querySelectorAll(".revit_card");
    }

    if (!revit_trackWidth && revit_cards_items) {
        revit_trackWidth = Array.from(revit_cards_items).reduce((acc, item) => acc + item.offsetWidth, 0);
    }

    if (!revit_carousel_obj) {
        revit_carousel_obj = document.querySelector(".revit_carousel");
        if (revit_carousel_obj) {
            revit_carousel_obj.addEventListener('mouseover', function () {
                revit_keepScrolling = false;
            });

            revit_carousel_obj.addEventListener('mouseout', function () {
                revit_keepScrolling = true;
            });
        }
    }

    if (!revit_carouselWidth && revit_carousel_obj) {
        revit_carouselWidth = revit_carousel_obj.offsetWidth;
    }

    return !!revit_track && revit_cards_items && !!revit_trackWidth && !!revit_carousel_obj;

}

const scrollCarousel = () => {
    let allIsInitiated = initScrollValues();
    console.debug(`allIsInitiated:${allIsInitiated}`)
    if (allIsInitiated) {
        revit_translateX -= revit_speed * revit_keepScrolling;
        console.debug(`revit_translateX:${revit_translateX}  revit_speed:${revit_speed} revit_keepScrolling:${revit_keepScrolling}`)
        // If the translation has reached the end of the track
        if (-revit_translateX >= revit_trackWidth + revit_carouselWidth) {
            // Reset the translation to the starting point for looping
            revit_translateX = 0;
        }

        // Apply the translation to the track
        revit_track.style.transform = `translateX(${revit_translateX}px)`;
    }
    requestAnimationFrame(scrollCarousel);

}


class MyComponent extends HTMLElement {
    constructor() {
        super();
        let cardBackgroundColor = "#FFFFFF";
        let fontColor = "#000000";
        let commentdBackgroundColor = "#FFFFFF";
        let commentdBorderColor = "#000000";
    }

    getPreviewReviews() {
        const reviews = []
        for (let i = 0; i < 250; i++) {
            reviews.push({
                "name": "Example Reviewer",
                "picture": "https://picsum.photos/200/300",
                "stars": 5,
                "link": "",
                "update_time_human": "1 day ago",
                "comment": "To connect your Google account and set up the carousel, click on the settings icon and select the 'Open Revit' button"
            })
            reviews.push({
                "name": "Empty Example Reviewer",
                "picture": "https://picsum.photos/200/300",
                "stars": 5,
                "link": "",
                "update_time_human": "1 day ago",
                "comment": ""
            })
        }
        return {"reviews": reviews};
    }

    setTheStyles() {
        const style = document.createElement('style');


        style.innerHTML = '@keyframes scroll {\n' +
            '  from {transform: translateX(0)}\n' +
            '  to {transform: translateX(-100%)}\n' +
            '}' +
            '.revit_comment p{\n' +
            '  max-height:7.5em;\n' +
            '  overflow: hidden;\n' +
            'max-height:7.675em;\n' +
            '}' +
            '.revit_read_more{\n' +
            '  text-align:center;\n' +
            'padding-top:0.5em;\n' +
            '}\n' +
            '.revit_read_more a{\n' +
            '  color:inherit;\n' +
            '}' +
            '.revit_carousel{\n' +
            '  width:100%;\n' +
            ' min-height:320px;\n' +
            '  overflow:hidden;\n' +
            '}\n' +
            '\n' +
            '.revit_track{\n' +
            '  display:flex;\n' +
            '  gap:2rem;\n' +
            '}\n' +
            '.revit_track:hover{\n' +
            'animation-play-state: paused;\n' +
            '}\n' +
            '\n' +
            '.revit_card {\n' +
            `background:${this.cardBackgroundColor};\n` +
            `color:${this.fontColor};\n` +
            '  padding:1.875em;\n' +
            '  width:21.875em;\n' +
            'height:19.688em;\n' +
            '  box-shadow: 0 0.25em 0.25em rgba(0, 0, 0, 0.25);\n' +
            '  border-radius:1em;\n' +
            ' flex-shrink: 0; \n' +
            '}\n' +
            '.grow { transition: all .2s ease-in-out; }\n' +
            '.grow:hover { transform: scale(1.1); }\n' +
            '\n' +
            '.revit_stars_and_glogo{\n' +
            '  display:flex;\n' +
            '  justify-content:space-between;\n' +
            '}\n' +
            '\n' +
            '.revit_comment {\n' +
            `background:${this.commentdBackgroundColor};\n` +
            '  padding:1.25em;\n' +
            '  border-radius:1em;\n' +
            `  border:1px solid ${this.commentdBorderColor};\n` +
            '  margin:2.125em 1em 0 1em;\n' +
            'font-size:1em;\n' +
            'box-shadow: 3px 4px 5px 0px rgba(0, 0, 0, 0.25);\n' +
            '}\n' +
            '\n' +
            '.revit_card_bottom{\n' +
            '  display:flex;\n' +
            '  justify-content:center;\n' +
            ' margin-top:0.5em;\n' +
            '}\n' +
            '\n' +
            '.revit_user_image{\n' +
            '  width:2.5em;\n' +
            '  height:2.5em;\n' +
            '  border-radius:50%;\n' +
            '}\n' +
            '\n' +
            '.revit_card_main{\n' +
            '  padding-bottom:1em;\n' +
            '}\n' +
            '\n' +
            '.revit_user_data{\n' +
            '  display:flex;\n' +
            '  gap:0.625em;\n' +
            '}\n' +
            '\n' +
            '.revit_star{\n' +
            'width:1.5em;\n' +
            '}';

//this.setAttribute('style', 'display:block')
        document.head.appendChild(style);
    }

    getJSON(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'text';
        xhr.onload = function () {
            var status = xhr.status;
            if (status === 200) {
                callback(null, xhr.response);
            } else {
                callback(status, xhr.response);
            }
        };
        xhr.send();
    };

    hexToRgba(hex, opacity) {
        try {

// Remove the # symbol if present
            if (hex.startsWith("#")) {
                hex = hex.slice(1);
            }

// Split the HEX value into red, green, and blue components
            const red = parseInt(hex.substring(0, 2), 16);
            const green = parseInt(hex.substring(2, 4), 16);
            const blue = parseInt(hex.substring(4, 6), 16);

            let alpha = 1;
// Calculate the opacity value
            try {
                alpha = parseInt(opacity)
                if (alpha > 1) {
                    alpha /= 100;
                }
                alpha = opacity.toFixed(2);
            } catch (e) {
                console.log('failed to parse alpha')
            }

// Return the RGBA string
            return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
        } catch (e) {
            console.log('failed to extract background')
            return null;
        }
    }


// Will be called with new wixsettings data for each change to the component data in the editor.
// Will be called once on live/preview mode (on page load)
    connectedCallback() {
  //      const wixconfig = JSON.parse(this?.attributes?.wixconfig?.value ?? '{}');
    //    console.log(wixconfig); // Empty since it's not a costume widget anymore
// current instanceId
        const instanceId = this.getAttribute('instanceId');
        const viewMode = this.getAttribute('viewMode');
        console.log(`store:${instanceId}`);
        console.log(`viewMode:${viewMode}`);
        if (viewMode === 'Editor' || viewMode === 'Preview') {
            this.setTheCarousel(this.getPreviewReviews());
        }


        this.getJSON(`https://storage.googleapis.com/wix_carousel_reviews/${instanceId}`, (err, result) => {
            console.error(err);
            this.setTheCarousel(JSON.parse(result));
        });
    }

    getBrighterColor(hexColor, factor) {
        // Remove the '#' symbol and split the color into its RGB components
        const r = parseInt(hexColor.slice(1, 3), 16);
        const g = parseInt(hexColor.slice(3, 5), 16);
        const b = parseInt(hexColor.slice(5, 7), 16);

        // Calculate the new RGB values by adding a factor to each component
        const newR = Math.min(255, r + factor);
        const newG = Math.min(255, g + factor);
        const newB = Math.min(255, b + factor);

        // Convert the new RGB values back to hexadecimal format
        const newHexColor = `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`;

        return newHexColor;
    }

    setUserPrefs(wixsettings) {
        try {

            let bgColor = wixsettings?.revitCardBackgroundColor?.customColor.value;
            let bgOpacity = wixsettings?.revitCardBackgroundColor?.customColor.opacity;

            let vfc = wixsettings?.revitFontColor?.customColor.value;

        } catch (e) {
            console.log('failed to load settings')
        }
    }

    setTheCarousel(reviews) {
        this.cardBackgroundColor = reviews?.carousel_settings?.cardBg;
        this.fontColor = reviews?.carousel_settings?.cardTextColor;
        this.commentdBackgroundColor = reviews?.carousel_settings?.commentBackground;
        this.commentdBorderColor = reviews?.carousel_settings?.cardBorderColor;
        this.setSpeed(reviews);
        this.setTheStyles();
        let read_more = reviews?.carousel_settings?.readMore ? reviews?.carousel_settings?.readMore : "Read more";
        let reviewCards = '';
        reviews.reviews.slice(0, 25).forEach(review => {
            let starColorStart = "#FFC700";

            if (reviews?.carousel_settings?.starsColor) {
                starColorStart = reviews?.carousel_settings?.starsColor;
            }

            let starColorEnd = this.getBrighterColor(starColorStart, 40);
            let star = `
<svg class="revit_star" viewBox="0 0 22 21" fill="none"
     xmlns="http://www.w3.org/2000/svg">
    <defs>
        <linearGradient id="paint0_linear_2_61" x1="11" y1="0" x2="11" y2="20.6256"
                        gradientUnits="userSpaceOnUse">
            <stop offset="0.0333335" stop-color="${starColorStart}"/>
            <stop offset="1" stop-color="${starColorEnd}"/>
        </linearGradient>
    </defs>
    <path d="M4.96463 20.5473C4.43389 20.8195 3.83164 20.3424 3.93889 19.7333L5.08013 13.2295L0.236023 8.61504C-0.216351 8.18329 0.0187734 7.39404 0.625147 7.30879L7.35988 6.3518L10.3629 0.402186C10.6337 -0.134062 11.3666 -0.134062 11.6375 0.402186L14.6405 6.3518L21.3752 7.30879C21.9816 7.39404 22.2167 8.18329 21.763 8.61504L16.9202 13.2295L18.0615 19.7333C18.1687 20.3424 17.5665 20.8195 17.0357 20.5473L10.9981 17.4453L4.96326 20.5473H4.96463Z"
          fill="url(#paint0_linear_2_61)"/>

</svg>
`
            let stars = ''
            for (let i = 0; i < review.stars; i++) {
                stars += star;
            }
            reviewCards += `
<div class="revit_card grow">
    <div class="revit_card_main">
        <div class="revit_stars_and_glogo">
            <div class="stars">
                ${stars}
            </div>
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                     fill="none">
                    <g clip-path="url(#clip0_2_58)">
                        <path
                                d="M23.766 12.2764C23.766 11.4607 23.6999 10.6406 23.5588 9.83807H12.24V14.4591H18.7217C18.4528 15.9494 17.5885 17.2678 16.323 18.1056V21.1039H20.19C22.4609 19.0139 23.766 15.9274 23.766 12.2764Z"
                                fill="#4285F4"/>
                        <path
                                d="M12.2401 24.0008C15.4766 24.0008 18.2059 22.9382 20.1945 21.1039L16.3276 18.1055C15.2517 18.8375 13.8627 19.252 12.2445 19.252C9.11388 19.252 6.45946 17.1399 5.50705 14.3003H1.5166V17.3912C3.55371 21.4434 7.7029 24.0008 12.2401 24.0008Z"
                                fill="#34A853"/>
                        <path
                                d="M5.50254 14.3003C4.99987 12.8099 4.99987 11.1961 5.50254 9.70575V6.61481H1.5165C-0.185503 10.0056 -0.185503 14.0004 1.5165 17.3912L5.50254 14.3003Z"
                                fill="#FBBC04"/>
                        <path
                                d="M12.2401 4.74966C13.9509 4.7232 15.6044 5.36697 16.8434 6.54867L20.2695 3.12262C18.1001 1.0855 15.2208 -0.034466 12.2401 0.000808666C7.7029 0.000808666 3.55371 2.55822 1.5166 6.61481L5.50264 9.70575C6.45064 6.86173 9.10947 4.74966 12.2401 4.74966Z"
                                fill="#EA4335"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_2_58">
                            <rect width="24" height="24" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>

            </div>
        </div>
        <div class="revit_comment">
            <p> ${review.comment}</p>
            <div class="revit_read_more">
                <a href="${review.link}" target="_blank">${!!review.comment ? read_more : ''}</a>
            </div>
        </div>
    </div>
    <div class="revit_card_bottom">
        <div class="revit_user_data">
            <img class="revit_user_image" src="${review.picture}"/>
            <div>
                <div>${review.name}</div>
                <div>${review.update_time_human}</div>
            </div>
        </div>
    </div>
</div>`
        })
        this.innerHTML = `
<div class='revit_carousel'>
    <div class="revit_track">
        ${reviewCards}
    </div>
</div>
`;


        scrollCarousel()
    }

    setSpeed(reviews) {
        try {
            let tempSpeed = parseInt(reviews?.carousel_settings?.carouselSpeed)
            if (typeof tempSpeed === 'number' && !isNaN(tempSpeed)) {
                tempSpeed = tempSpeed / 10;
                revit_speed = tempSpeed;
            }
        } catch (e) {
            console.log(`failed to parse speed ${reviews?.carousel_settings}`)
        }
    }
}

//my-tag should be the same as the tag name in the custom element's definition in the Developers' Center.
customElements.define('review-carousel', MyComponent);
